module.exports = __webpack_public_path__ + "img/Bylaws.0ee373a4.svg";